import {
    FETCHED_USERS,
    FETCHED_USER_ROLES,
    FETCH_USER,
    FETCHED_USER_SITES,
    FETCHED_USER_LANGUAGES,
    UPDATED_USER_ROLES,
    FETCHED_PERMISSIONS_GROUPED,
    FETCHED_USER_PERMISSIONS
} from './types';

export function fetchedUsers(data, totalPages) {
    return {
        type: FETCHED_USERS,
        payload: {
            data: data,
            totalPages: totalPages
        }
    }
}

export function fetchedUser(user) {
    return {
        type: FETCH_USER,
        user
    };
}

export function fetchedUserRoles(roles) {
    return {
        type: FETCHED_USER_ROLES,
        roles
    }
}

export function fetchedUserSites(userSites) {
    return {
        type: FETCHED_USER_SITES,
        userSites
    }
}

export function fetchedUserLanguages(userLanguages) {
    return {
        type: FETCHED_USER_LANGUAGES,
        userLanguages
    }
}

export function updatedUserRoles(data) {
    return {
        type: UPDATED_USER_ROLES,
        data
    }
}

export function fetchedPermissionsGrouped(groupedPermissions) {
    return {
        type: FETCHED_PERMISSIONS_GROUPED,
        groupedPermissions
    }
}

export function fetchedUserPermissions(userPermissions) {
    return {
        type: FETCHED_USER_PERMISSIONS,
        userPermissions
    }
}


// WEBPACK FOOTER //
// ./src/containers/users/actions.js